let loaded = false;

export function initGtag() {
  const id = process.env.REACT_APP_GOOGLE_ADS_ID;
  if (!id || loaded) return;
  if (localStorage.getItem("bps-consent") !== "accept") return;
  loaded = true;
  const s = document.createElement("script");
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", id);
}

export function reportPurchase({ value, currency, transactionId }) {
  const id = process.env.REACT_APP_GOOGLE_ADS_ID;
  const label = process.env.REACT_APP_GOOGLE_ADS_PURCHASE_LABEL;
  if (!id || !label || !window.gtag) return;
  window.gtag("event", "conversion", {
    send_to: `${id}/${label}`,
    value,
    currency: (currency || "usd").toUpperCase(),
    transaction_id: transactionId,
  });
}
